import script from "./MediaManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaManagement.vue?vue&type=script&setup=true&lang=js"

import "./MediaManagement.vue?vue&type=style&index=0&id=6b08f0e7&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b08f0e7"]])

export default __exports__